/**
 * jQuery plugin that serialises a form into a plain object.
 * Defined once here so inline widget-admin scripts can rely on it
 * without re-declaring it in every view.
 */
if (typeof $.fn.serializeObject === 'undefined') {
  $.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();

    $.each(a, function () {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });

    return o;
  };
}
